import { useState } from "react";

import heroPhoto from "./Assets/andrew-cutout.png";
import fieldPhoto from "./Assets/andrew-fieldwork.jpg";
import capsPhoto from "./Assets/andrew-caps.jpg";

const COLORS = {
  blue: "#0B4F8A",
  blueDark: "#062E55",
  blueLight: "#2B8FD6",
  green: "#1F9D6A",
  greenLight: "#4CC38F",
  white: "#FFFFFF",
  mist: "#F1F8FB",
  text: "#0A2540",
  muted: "#54687D",
};

const EMAIL = "AndrewForSSWD@gmail.com";
const REGISTER_URL = "https://registertovote.ca.gov";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,600;9..144,800&family=Source+Sans+3:wght@400;600;700&display=swap');
  * { margin: 0; padding: 0; box-sizing: border-box; }
  html { scroll-behavior: smooth; }
  body { font-family: 'Source Sans 3', system-ui, sans-serif; background: ${COLORS.white}; color: ${COLORS.text}; line-height: 1.6; }
  h1, h2, h3, .display { font-family: 'Fraunces', Georgia, serif; text-wrap: balance; }
  a:focus-visible, button:focus-visible { outline: 3px solid ${COLORS.greenLight}; outline-offset: 2px; }
  .site { overflow-x: hidden; }
  .wrap { max-width: 1120px; margin: 0 auto; padding: 0 1.25rem; }
  section { scroll-margin-top: 68px; }

  nav { position: fixed; top: 0; width: 100%; z-index: 100; height: 68px; background: rgba(6,46,85,.96); backdrop-filter: blur(8px); border-bottom: 3px solid ${COLORS.green}; }
  nav .wrap { height: 100%; display: flex; align-items: center; justify-content: space-between; }
  .nav-logo { font-family: 'Fraunces', serif; font-weight: 800; font-size: 1.25rem; color: #fff; }
  .nav-logo span { color: ${COLORS.greenLight}; }
  .nav-links { display: flex; gap: 1.75rem; list-style: none; align-items: center; }
  .nav-links a { color: #D6E8F5; text-decoration: none; font-size: .85rem; letter-spacing: .08em; text-transform: uppercase; font-weight: 600; }
  .nav-links a:hover { color: ${COLORS.greenLight}; }
  .nav-links a.nav-cta { background: ${COLORS.green}; color: #fff; padding: .5rem 1.1rem; border-radius: 999px; }
  .nav-links a.nav-cta:hover { background: ${COLORS.greenLight}; color: ${COLORS.blueDark}; }
  .hamburger { display: none; cursor: pointer; flex-direction: column; gap: 5px; padding: 8px; background: none; border: 0; }
  .hamburger span { display: block; width: 24px; height: 2px; background: #fff; }
  .mobile-menu { display: none; position: fixed; top: 68px; left: 0; right: 0; z-index: 99; background: ${COLORS.blueDark}; padding: .5rem 1.25rem 1.25rem; flex-direction: column; }
  .mobile-menu.open { display: flex; }
  .mobile-menu a { color: #fff; text-decoration: none; padding: .9rem 0; border-bottom: 1px solid rgba(255,255,255,.12); text-transform: uppercase; letter-spacing: .08em; font-size: .95rem; }

  .hero { padding-top: 68px; color: #fff; position: relative; overflow: hidden;
    background: linear-gradient(135deg, ${COLORS.blueDark} 0%, ${COLORS.blue} 55%, #0E7C86 100%); }
  .hero::after { content: ''; position: absolute; left: 0; right: 0; bottom: -1px; height: 90px; background: #fff;
    clip-path: path('M0 60 C 240 10, 480 110, 720 60 S 1200 10, 1440 60 L1440 90 L0 90 Z'); }
  .hero .wrap { display: grid; grid-template-columns: 1.1fr .9fr; gap: 2rem; align-items: end; padding-top: 3.5rem; padding-bottom: 0; position: relative; z-index: 1; }
  .hero-text { padding-bottom: 6.5rem; align-self: center; }
  .eyebrow { font-size: .85rem; letter-spacing: .18em; text-transform: uppercase; color: ${COLORS.greenLight}; font-weight: 700; margin-bottom: 1rem; }
  .hero h1 { font-size: clamp(3rem, 7vw, 5.2rem); line-height: 1; font-weight: 800; margin-bottom: 1rem; }
  .hero h1 em { color: ${COLORS.greenLight}; font-style: normal; }
  p:empty, h2:empty, h3:empty, .tag:empty, .fact:empty { display: none; }
  .hero-roles { font-size: 1.2rem; color: #CFE6F5; margin-bottom: 1.75rem; }
  .hero-tags { display: flex; flex-wrap: wrap; gap: .6rem; margin-bottom: 2rem; }
  .tag { border: 1.5px solid rgba(255,255,255,.55); padding: .35rem 1rem; border-radius: 999px; font-weight: 600; font-size: .95rem; }
  .tag::before { content: '✓ '; color: ${COLORS.greenLight}; }
  .btns { display: flex; gap: .9rem; flex-wrap: wrap; }
  .btn { display: inline-block; text-decoration: none; padding: .85rem 1.8rem; border-radius: 999px; font-weight: 700; font-size: .95rem; letter-spacing: .04em; border: 2px solid transparent; cursor: pointer; font-family: inherit; }
  .btn-green { background: ${COLORS.green}; color: #fff; }
  .btn-green:hover { background: ${COLORS.greenLight}; color: ${COLORS.blueDark}; }
  .btn-white { background: #fff; color: ${COLORS.blue}; }
  .btn-white:hover { background: ${COLORS.mist}; }
  .btn-ghost { border-color: rgba(255,255,255,.6); color: #fff; }
  .btn-ghost:hover { background: rgba(255,255,255,.12); }
  .hero-photo { position: relative; display: flex; justify-content: center; align-items: flex-end; }
  .hero-photo img { display: block; width: 100%; max-width: 430px; height: auto; position: relative; z-index: 1; margin-bottom: -1px; }
  .hero-date { position: absolute; top: 8%; left: 0; z-index: 2; background: ${COLORS.green}; color: #fff; width: 118px; height: 118px; border-radius: 50%; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; box-shadow: 0 8px 24px rgba(0,0,0,.3); border: 4px solid #fff; }
  .hero-date small { font-size: .78rem; letter-spacing: .1em; text-transform: uppercase; font-weight: 700; }
  .hero-date b { font-family: 'Fraunces', serif; font-size: 2.2rem; line-height: 1; }

  .section { padding: 5rem 0; }
  .label { font-size: .8rem; letter-spacing: .2em; text-transform: uppercase; font-weight: 700; color: ${COLORS.green}; margin-bottom: .6rem; }
  .heading { font-size: clamp(2rem, 4vw, 2.9rem); line-height: 1.12; font-weight: 800; color: ${COLORS.blue}; margin-bottom: 1.25rem; }

  .about-grid { display: grid; grid-template-columns: 1fr 1.25fr; gap: 3.5rem; align-items: start; }
  .photo-stack { display: flex; flex-direction: column; gap: 1.25rem; min-width: 0; }
  .photo-stack figure { border-radius: 14px; overflow: hidden; background: ${COLORS.mist}; box-shadow: 0 10px 30px rgba(6,46,85,.15); }
  .photo-stack img { display: block; width: 100%; height: 340px; object-fit: cover; object-position: center 25%; }
  .photo-stack figcaption { padding: .6rem 1rem; font-size: .85rem; color: ${COLORS.muted}; }
  .about-text { min-width: 0; }
  .about-text p { font-size: 1.1rem; color: #2C4359; margin-bottom: 1.1rem; }
  .facts { display: flex; flex-wrap: wrap; gap: .7rem; margin-top: 1.5rem; }
  .fact { background: ${COLORS.mist}; border-left: 4px solid ${COLORS.green}; padding: .6rem 1rem; font-weight: 600; color: ${COLORS.blue}; border-radius: 4px; }

  #platform { background: linear-gradient(180deg, ${COLORS.blue}, ${COLORS.blueDark}); color: #fff; }
  #platform .heading { color: #fff; }
  #platform .label { color: ${COLORS.greenLight}; }
  .intro { max-width: 620px; color: #CFE6F5; font-size: 1.1rem; margin-bottom: 2.5rem; }
  .cards { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.5rem; }
  .card { background: rgba(255,255,255,.08); border: 1px solid rgba(255,255,255,.2); border-radius: 14px; padding: 2rem; min-width: 0; }
  .card svg { width: 52px; height: 52px; margin-bottom: 1rem; }
  .card h3 { font-size: 1.4rem; margin-bottom: .6rem; }
  .card p { color: #DCEBF6; font-size: 1rem; }

  .endorse-list { list-style: none; display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 1rem; }
  .endorse-list li { background: ${COLORS.mist}; border-left: 4px solid ${COLORS.green}; border-radius: 8px; padding: 1.1rem 1.25rem; font-family: 'Fraunces', Georgia, serif; font-weight: 600; font-size: 1.15rem; color: ${COLORS.blue}; }

  #get-involved { background: ${COLORS.mist}; }
  #get-involved .panel { background: #fff; }
  .involved { display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; }
  .panel { background: #fff; border-radius: 14px; padding: 2rem; box-shadow: 0 6px 24px rgba(6,46,85,.08); min-width: 0; }
  .panel h3 { font-size: 1.5rem; color: ${COLORS.blue}; margin-bottom: .5rem; }
  .panel p { color: ${COLORS.muted}; margin-bottom: 1.25rem; }
  .vol { display: flex; flex-direction: column; gap: .6rem; margin-bottom: 1.25rem; }
  .vol button { display: flex; justify-content: space-between; align-items: center; text-align: left; font: inherit; padding: .75rem 1rem; border-radius: 10px; border: 2px solid #D5E4EE; background: #fff; color: ${COLORS.text}; cursor: pointer; }
  .vol button.on { border-color: ${COLORS.green}; background: #E8F7F0; font-weight: 600; }
  .vol button.on::after { content: '✓'; color: ${COLORS.green}; font-weight: 700; }
  .note { font-size: .9rem; color: ${COLORS.muted}; margin-top: .75rem; }

  #contact { background: ${COLORS.blueDark}; color: #fff; }
  #contact .heading { color: #fff; }
  #contact .label { color: ${COLORS.greenLight}; }
  .contact-grid { display: grid; grid-template-columns: 1fr 1.2fr; gap: 3rem; }
  .contact-grid p { color: #CFE6F5; margin-bottom: 1rem; }
  .email-line { font-size: 1.15rem; font-weight: 700; color: #fff; word-break: break-all; }
  .form { display: flex; flex-direction: column; gap: .9rem; min-width: 0; }
  .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: .9rem; }
  .form input, .form textarea { width: 100%; padding: .85rem 1rem; border-radius: 10px; border: 1.5px solid rgba(255,255,255,.3); background: rgba(255,255,255,.08); color: #fff; font: inherit; }
  .form input::placeholder, .form textarea::placeholder { color: #A9C6DC; }
  .form textarea { min-height: 120px; resize: vertical; }
  .success { border: 1.5px solid ${COLORS.greenLight}; border-radius: 10px; padding: 1.25rem; color: #fff; }

  footer { background: #041F3B; color: #9FBBD3; padding: 2rem 0; font-size: .85rem; }
  footer .wrap { display: flex; justify-content: space-between; gap: 1rem; flex-wrap: wrap; align-items: center; }
  footer .nav-logo { font-size: 1.1rem; }

  @media (max-width: 860px) {
    .nav-links { display: none; }
    .hamburger { display: flex; }
    .hero .wrap { grid-template-columns: 1fr; padding-top: 2rem; }
    .hero-text { padding-bottom: 0; text-align: center; }
    .hero-tags, .btns { justify-content: center; }
    .hero-photo { padding-bottom: 5rem; }
    .hero-photo img { max-width: 320px; }
    .hero-date { left: 4%; width: 92px; height: 92px; }
    .hero-date b { font-size: 1.7rem; }
    .about-grid, .cards, .involved, .contact-grid { grid-template-columns: 1fr; gap: 1.5rem; }
    .form-row { grid-template-columns: 1fr; }
    .section { padding: 3.5rem 0; }
  }
`;

const icons = {
  dollar: (
    <svg viewBox="0 0 52 52" fill="none" aria-hidden="true"><circle cx="26" cy="26" r="24" stroke="#4CC38F" strokeWidth="3"/><path d="M26 12v28M32 19c-1-3-4-4-6-4-3 0-6 1.7-6 5s3 4.5 6 5.500 6 2 6 5.500-3 5-6 5c-3 0-6-1.5-7-4.500" stroke="#fff" strokeWidth="3" strokeLinecap="round"/></svg>
  ),
  leaf: (
    <svg viewBox="0 0 52 52" fill="none" aria-hidden="true"><circle cx="26" cy="26" r="24" stroke="#4CC38F" strokeWidth="3"/><path d="M14 38c0-14 8-22 24-22 0 16-8 24-22 24M14 38l14-14" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/></svg>
  ),
  drop: (
    <svg viewBox="0 0 52 52" fill="none" aria-hidden="true"><circle cx="26" cy="26" r="24" stroke="#4CC38F" strokeWidth="3"/><path d="M26 10c8 10 12 16 12 22a12 12 0 0 1-24 0c0-6 4-12 12-22Z" stroke="#fff" strokeWidth="3" strokeLinejoin="round"/></svg>
  ),
};

const priorities = [
  { icon: icons.dollar, title: "Affordability", desc: "Safe, affordable, and available drinking water is a fundamental right, not a luxury. My operational background helps me find cost-saving technical efficiencies, working with staff and the community to prevent unnecessary rate burdens while keeping the district financially solvent. If there is a savings to be had, I will pursue it. If a rate increase is needed, you will know exactly why." },
  { icon: icons.leaf, title: "Sustainability", desc: "Safeguarding our local water supply means balancing surface water entitlements with the long-term health of our regional groundwater basins. My goal is to harden our infrastructure and water supply against the challenges ahead from dwindling natural resources." },
  { icon: icons.drop, title: "Transparency", desc: "You have a right to know how your district operates, and that goes beyond a public board meeting once or twice a month. I want to expand how the district engages with you, from a presence at local festivals to field trip opportunities with local schools, so you know who we are and where to find us." },
];

const endorsements = [
  "Latino Democratic Club",
  "Democratic Party of Sacramento County",
  "Sacramento Central Labor Council, AFL-CIO",
  "American River Democrats",
  "JFK Democratic Club",
];

const volunteerOptions = ["Door knocking", "Yard signs", "Host a meet and greet", "Social media", "Postcards and letters"];

export default function CampaignSite() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [picked, setPicked] = useState([]);
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", message: "" });

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };
  const toggle = (v) => setPicked((p) => (p.includes(v) ? p.filter((x) => x !== v) : [...p, v]));

  const mailtoVolunteer = `mailto:${EMAIL}?subject=${encodeURIComponent("Volunteer for Andrew")}&body=${encodeURIComponent(
    picked.length ? `I'd like to help with: ${picked.join(", ")}` : "I'd like to volunteer."
  )}`;
  const mailtoContact = `mailto:${EMAIL}?subject=${encodeURIComponent(`Message from ${form.firstName} ${form.lastName}`.trim())}&body=${encodeURIComponent(`${form.message}\n\n${form.email}`)}`;

  const links = [["About", "about"], ["Platform", "platform"], ["Endorsements", "endorsements"], ["Get Involved", "get-involved"], ["Contact", "contact"]];

  return (
    <>
      <style>{styles}</style>
      <div className="site">
        <nav>
          <div className="wrap">
            <div className="nav-logo">Andrew <span>Consiglio</span></div>
            <ul className="nav-links">
              {links.map(([l, id]) => (
                <li key={id}><a href={`#${id}`} onClick={(e) => { e.preventDefault(); scrollTo(id); }}>{l}</a></li>
              ))}
              <li><a className="nav-cta" href={REGISTER_URL} target="_blank" rel="noopener noreferrer">Register to Vote</a></li>
            </ul>
            <button className="hamburger" aria-label="Menu" onClick={() => setMobileOpen(!mobileOpen)}><span /><span /><span /></button>
          </div>
        </nav>
        <div className={`mobile-menu${mobileOpen ? " open" : ""}`}>
          {links.map(([l, id]) => (
            <a key={id} href={`#${id}`} onClick={(e) => { e.preventDefault(); scrollTo(id); }}>{l}</a>
          ))}
          <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer">Register to Vote</a>
        </div>

        <section className="hero" id="hero">
          <div className="wrap">
            <div className="hero-text">
              <div className="eyebrow">Sacramento Suburban Water District · Division 1</div>
              <h1>Andrew <em>Consiglio</em></h1>
              <p className="hero-roles">For D1 Director · Environmental Scientist · Water Operator</p>
              <div className="hero-tags">
                {["Safe", "Affordable", "Available"].map((t) => (<span className="tag" key={t}>{t}</span>))}
              </div>
              <div className="btns">
                <a className="btn btn-green" href="#platform" onClick={(e) => { e.preventDefault(); scrollTo("platform"); }}>My Priorities</a>
                <a className="btn btn-ghost" href="#get-involved" onClick={(e) => { e.preventDefault(); scrollTo("get-involved"); }}>Get Involved</a>
              </div>
            </div>
            <div className="hero-photo">
              <div className="hero-date"><small>Vote</small><b>Nov 3</b></div>
              <img src={heroPhoto} alt="Andrew Consiglio in a blue plaid blazer" />
            </div>
          </div>
        </section>

        <section id="about" className="section">
          <div className="wrap about-grid">
            <div className="photo-stack">
              <figure><img src={fieldPhoto} alt="Andrew in a hard hat and safety vest at a water facility" /><figcaption>On the job as a water operator</figcaption></figure>
              <figure><img src={capsPhoto} alt="Andrew smiling in a California Association of Professional Scientists shirt" /><figcaption>Scientist and community member</figcaption></figure>
            </div>
            <div className="about-text">
              <div className="label">About Andrew</div>
              <h2 className="heading">Practical experience for our water</h2>
              <p>I am running for the Sacramento Suburban Water District (SSWD) Division 1 Board of Directors to bring practical, experience-based leadership directly to our water utility. Our community deserves a board member who understands the technical realities of water infrastructure, treats public health as a top priority, and is committed to transparency, sustainability, and affordability.</p>
              <p><strong>6 years of direct water treatment experience.</strong> I have spent over half a decade working within critical water infrastructure, including industrial water treatment, wastewater treatment, and drinking water treatment. I understand the everyday realities of treating, testing, and distributing high-quality water safely to working families.</p>
              <p><strong>Certified Water Treatment Operator.</strong> I earned my California Water Treatment Operator Grade T3 Certification while working as a drinking water operator at the county level. It represents mastery of the safety standards, mechanical processes, and state regulations required to manage a public water treatment plant, and I hope to bring that experience to the Board.</p>
              <p><strong>Degree in Water Quality and Hazardous Materials.</strong> My education helps me make informed decisions about the direction of the district, whether that means finding issues in our maintenance budget or managing the cleanup of an unused contaminated groundwater well.</p>
              <p><strong>Current Environmental Scientist.</strong> Today I specialize in hazardous waste cleanup. Every day I analyze complex data to protect the public from hazardous material releases, while working with the communities I serve to make sure their interests are represented.</p>
              <div className="facts">
                {["6 years in water treatment", "Grade T3 certified operator", "Degree in Water Quality & Hazmat"].map((f) => (<span className="fact" key={f}>{f}</span>))}
              </div>
            </div>
          </div>
        </section>

        <section id="platform" className="section">
          <div className="wrap">
            <div className="label">Priorities</div>
            <h2 className="heading">My commitments to SSWD ratepayers</h2>
            <p className="intro">Committed to making sure our water is safe, affordable, and available, now and into the future.</p>
            <div className="cards">
              {priorities.map((p) => (
                <div className="card" key={p.title}>{p.icon}<h3>{p.title}</h3><p>{p.desc}</p></div>
              ))}
            </div>
          </div>
        </section>

        <section id="endorsements" className="section">
          <div className="wrap">
            <div className="label">Endorsements</div>
            <h2 className="heading">Proudly endorsed by</h2>
            <ul className="endorse-list">
              {endorsements.map((e) => (<li key={e}>{e}</li>))}
            </ul>
          </div>
        </section>

        <section id="get-involved" className="section">
          <div className="wrap">
            <div className="label">Get Involved</div>
            <h2 className="heading">Join the campaign for SSWD Division 1</h2>
            <div className="involved">
              <div className="panel">
                <h3>Register to vote</h3>
                <p>Election Day is November 3. Make sure you are registered so your voice is heard on the future of our water.</p>
                <a className="btn btn-green" href={REGISTER_URL} target="_blank" rel="noopener noreferrer">Register to Vote</a>
              </div>
              <div className="panel">
                <h3>Volunteer</h3>
                <p>Pick the ways you would like to help, then send an email to the campaign.</p>
                <div className="vol">
                  {volunteerOptions.map((v) => (
                    <button key={v} className={picked.includes(v) ? "on" : ""} onClick={() => toggle(v)}>{v}</button>
                  ))}
                </div>
                <a className="btn btn-green" href={mailtoVolunteer}>Email to Volunteer</a>
                
              </div>
            </div>
          </div>
        </section>

        <section id="contact" className="section">
          <div className="wrap contact-grid">
            <div>
              <div className="label">Contact</div>
              <h2 className="heading">Questions? Let's talk.</h2>
              <p>If you have a question about the district or the campaign, I want you to be able to reach me. Vote Andrew Consiglio for SSWD Division 1.</p>
              <div className="email-line">{EMAIL}</div>
            </div>
            <div>
              {sent ? (
                <div className="success">Your email app should open with your message. If it does not, write to {EMAIL}.</div>
              ) : (
                <div className="form">
                  <div className="form-row">
                    <input id="fn" aria-label="First name" placeholder="First name" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} />
                    <input id="ln" aria-label="Last name" placeholder="Last name" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} />
                  </div>
                  <input id="em" type="email" aria-label="Email address" placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                  <textarea id="msg" aria-label="Message" placeholder="Your message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
                  <a className="btn btn-green" style={{ alignSelf: "flex-start" }} href={mailtoContact} onClick={() => setSent(true)}>Send Message</a>
                </div>
              )}
            </div>
          </div>
        </section>

        <footer>
          <div className="wrap">
            <div className="nav-logo">Andrew <span>Consiglio</span></div>
            <div>Paid for by [committee name and FPPC ID to be added]</div>
          </div>
        </footer>
      </div>
    </>
  );
}
